// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"7a77ebbf","320":"d6faeb14","457":"7ada65d7","466":"885470c4","522":"48195f72","679":"61a4d419","794":"559d6cc7","963":"e16ed954","990":"9baf09c0","993":"9733876e"}[chunkId] + ".chunk.js";
};